import { useState } from 'react';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { DialogFooter } from '@/components/ui/dialog';
import { toast } from 'sonner';

export default function DoctorForm({ initial = null, extra = {}, onSaved, onCancel, submitLabel }) {
    const [f, setF] = useState({
        name: initial?.name || '', specialty: initial?.specialty || '', phone: initial?.phone || '',
        fax: initial?.fax || '', address: initial?.address || '',
    });
    const [busy, setBusy] = useState(false);
    const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });
    const shared = (initial?.usage?.household_count || 0) > 1;
    const save = async () => {
        if (!f.name.trim()) { toast.error('Name is required'); return; }
        setBusy(true);
        try {
            const body = {
                name: f.name.trim(), specialty: f.specialty.trim() || null, phone: f.phone.trim() || null,
                fax: f.fax.trim() || null, address: f.address.trim() || null,
            };
            const { data } = initial
                ? await api.patch(`/doctors/${initial.provider_id}`, body)
                : await api.post('/doctors', { ...body, ...extra });
            toast.success(initial ? 'Doctor updated' : 'Doctor added');
            onSaved?.(data);
        } catch (e) { toast.error(e.response?.data?.detail?.message || e.response?.data?.detail || 'Failed'); }
        finally { setBusy(false); }
    };
    return (
        <div className="space-y-3" data-testid="doctor-form">
            {shared && (
                <div data-testid="doctor-shared-hint" className="text-[13px] rounded-lg border border-amber-200 bg-amber-50 text-amber-900 px-3 py-2">
                    This doctor is used by other households — changes apply everywhere.
                </div>
            )}
            <div><Label>Name</Label><Input data-testid="doctor-name" autoFocus value={f.name} onChange={upd('name')} placeholder='e.g., "Dr. Elena Park"' /></div>
            <div><Label>Specialty</Label><Input data-testid="doctor-specialty" value={f.specialty} onChange={upd('specialty')} placeholder="Cardiology" /></div>
            <div className="grid grid-cols-2 gap-3">
                <div><Label>Phone</Label><Input data-testid="doctor-phone" type="tel" value={f.phone} onChange={upd('phone')} /></div>
                <div><Label>Fax</Label><Input data-testid="doctor-fax" type="tel" value={f.fax} onChange={upd('fax')} /></div>
            </div>
            <div><Label>Address</Label><Input data-testid="doctor-address" value={f.address} onChange={upd('address')} /></div>
            <DialogFooter className="gap-2">
                {onCancel && <Button type="button" variant="outline" className="rounded-full min-h-[44px] sm:min-h-0" onClick={onCancel}>Cancel</Button>}
                <Button data-testid="doctor-save" onClick={save} disabled={busy} className="rounded-full bg-primary text-primary-foreground min-h-[44px] sm:min-h-0">
                    {submitLabel || (initial ? 'Save' : 'Add doctor')}
                </Button>
            </DialogFooter>
        </div>
    );
}
